// src/photos.js
export const sportPhotos = [
  {
    src: "/images/sport/ufc1.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/sport/ufc2.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/sport/ufc3.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/sport/ufc6.webp",
    width: 900,
    height: 600,
  },
 {
    src: "/images/sport/ufc7.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/sport/ufc8.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/sport/ufc9.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/sport/ufc10.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/sport/ufc11.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-12.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-13.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-14.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-15.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-16.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-17.webp",
    width: 900,
    height: 600,
  },
    {
    src: "/images/sport/ufc-18.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-19.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-20.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-21.webp",
    width: 900,
    height: 600,
  },
    {
    src: "/images/sport/ufc-22.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-23.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-24.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/sport/ufc-25.webp",
    width: 600,
    height: 900,
  },
];

export const cafePhotos = [
  {
    src: "/images/cafe/cafe1.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe2.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe3.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe4.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe5.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe6.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe7.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe8.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe9.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe10.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe11.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe12.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/cafe/cafe13.webp",
    width: 600,
    height: 900,
  },
]

export const torontoPhotos = [
  {
    src: "/images/toronto/toronto1.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/toronto/toronto2.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto3.webp",
    width: 900,
    height: 600,
  },
    {
    src: "/images/toronto/toronto4.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto5.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto6.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto7.webp",
    width: 900,
    height: 600,
  },
    {
    src: "/images/toronto/toronto8.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto9.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto10.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto11.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto12.webp",
    width: 600,
    height: 900,
  },
    {
    src: "/images/toronto/toronto13.webp",
    width: 600,
    height: 900,
  },
      {
    src: "/images/toronto/toronto14.webp",
    width: 900,
    height: 600,
  },
      {
    src: "/images/toronto/toronto15.webp",
    width: 600,
    height: 900,
  },
      {
    src: "/images/toronto/toronto16.webp",
    width: 600,
    height: 900,
  },
      {
    src: "/images/toronto/toronto17.webp",
    width: 600,
    height: 900,
  },
]

export const resorPhotos = [
  {
    src: "/images/gotland/gotland1.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/gotland/gotland2.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/gotland/gotland3.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/gotland/gotland4.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/gotland/gotland5.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/gotland/gotland6.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/gotland/gotland7.webp",
    width: 600,
    height: 900,
  },
    {
        src: "/images/gotland/gotland8.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland9.webp",
        width: 900,
        height: 600,
    },
    {
        src: "/images/gotland/gotland10.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland11.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland12.webp",
        width: 900,
        height: 600,
    },
    {
        src: "/images/gotland/gotland13.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland14.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland15.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland16.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/gotland/gotland17.webp",
        width: 600,
        height: 900,
    },
]; 

export const volleybollPhotos = [
  {
    src: "/images/volleyboll/volleyboll-1.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/volleyboll/volleyboll-2.webp",
    width: 900,
    height: 600,
  },
  {
    src: "/images/volleyboll/volleyboll-3.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/volleyboll/volleyboll-4.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/volleyboll/volleyboll-5.webp",
    width: 600,
    height: 900,
  },
  {
    src: "/images/volleyboll/volleyboll-6.webp",
    width: 800,
    height: 600,
  },
  {
    src: "/images/volleyboll/volleyboll-7.webp",
    width: 600,
    height: 900,
  },
    {
        src: "/images/volleyboll/volleyboll-8.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/volleyboll/volleyboll-9.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/volleyboll/volleyboll-10.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/volleyboll/volleyboll-11.webp",
        width: 800,
        height: 600,
    },
    {
        src: "/images/volleyboll/volleyboll-12.webp",
        width: 600,
        height: 900,
    },
    {
        src: "/images/volleyboll/volleyboll-13.webp",
        width: 600,
        height: 900,
    },
];